// extracted by mini-css-extract-plugin
export default {"gem":"headerBuilder_gem__m9JDi","logoText":"headerBuilder_logoText__g87Ma"};